function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components: {
    Multiselect: Multiselect
  },
  props: {
    group: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapState({
    frequency_groups: function frequency_groups(s) {
      return s.frequency_groups.frequencyGroups;
    }
  }), {
    // Format options as a option group named 'All'
    // Simplest way to allow to select all with an option.
    // See: https://github.com/shentao/vue-multiselect/issues/563
    options: function options() {
      var allDefaultName = this.$t('result.matching_expressions.groups.all');
      var allOptionName = this.$tOr('result.matching_expressions.groups', "".concat(this.group, ".values.all"), allDefaultName);
      return [{
        name: allOptionName,
        values: this.$ncsConfig.result.matching_expressions.frequency_group_values[this.group]
      }];
    },
    selected: {
      get: function get() {
        return this.frequency_groups[this.group];
      },
      set: function set(values) {
        this.$store.dispatch('frequency_groups/setFrequencyGroupValues', {
          group: this.group,
          values: values
        });
      }
    },
    label: function label() {
      return this.$t("groups.selector.label");
    }
  }),
  methods: {
    i18nOption: function i18nOption(option) {
      return this.$tOr('result.matching_expressions.groups', "".concat(this.group, ".values.").concat(option), option);
    }
  }
};